"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const logging_1 = __importDefault(require("../logging"));
class DiagnosticsBatcher extends events_1.EventEmitter {
    constructor(flushIntervalMillis = 300000) {
        super();
        this.logEvents = new Array();
        logging_1.default.on("log", this.handleLogEvent.bind(this));
        setInterval(this.flushDiagnostics.bind(this), flushIntervalMillis);
    }
    getDiagnostics() {
        return { logs: this.logEvents };
    }
    flushDiagnostics() {
        this.emit("diagnostics", this.getDiagnostics());
        this.logEvents = new Array();
    }
    handleLogEvent(level, timestamp, ...args) {
        this.logEvents.push({
            level,
            timestamp,
            message: args,
        });
    }
}
exports.DiagnosticsBatcher = DiagnosticsBatcher;
//# sourceMappingURL=diagnostics.js.map